import logoSrc from "@/assets/zyntra-logo.png";

interface ZyntraLogoProps {
  className?: string;
  alt?: string;
}

/**
 * Official Zyntra Tickets brand mark.
 * Rendered with a fully transparent background so it adapts to any surface
 * (header, footer, hero, modals) without showing a visible box.
 */
export function ZyntraLogo({
  className = "",
  alt = "Zyntra Tickets",
}: ZyntraLogoProps) {
  return (
    <img
      src={logoSrc}
      alt={alt}
      className={`object-contain ${className}`}
      draggable={false}
    />
  );
}
